import { render } from "./ViewUserTraining.vue?vue&type=template&id=180a5dbc&scoped=true"
import script from "./ViewUserTraining.vue?vue&type=script&lang=js"
export * from "./ViewUserTraining.vue?vue&type=script&lang=js"

import "./ViewUserTraining.vue?vue&type=style&index=0&id=180a5dbc&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180a5dbc"]])

export default __exports__